import { render } from "./AddWarehouseView.vue?vue&type=template&id=53231348&scoped=true&ts=true"
import script from "./AddWarehouseView.vue?vue&type=script&lang=ts"
export * from "./AddWarehouseView.vue?vue&type=script&lang=ts"

import "./AddWarehouseView.vue?vue&type=style&index=0&id=53231348&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53231348"]])

export default __exports__